import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuCollapsible } from 'app/domains/common-ui';
import { useCompanyFeatures } from 'app/domains/companies';
import { useRole } from 'app/domains/users';
import { useDesktopNavigation } from '../../../DesktopNavigation';
import { CollapsibleItemLink } from '../CollapsibleItemLink';
import { useLinkMatch } from '../useLinkMatch';
export function CollapsibleSettings() {
    const { collapsibleStates, toggleCollapsible } = useDesktopNavigation();
    const { isFeatureAvailable } = useCompanyFeatures();
    const userRole = useRole();
    const isWorkflowsAvailable = isFeatureAvailable('document-assistant:workflows:beta');
    const activeChild = useLinkMatch({
        matchPath: ['/users-teams', '/account', '/integrations', '/rules'],
        matchExact: false,
    });
    return (<SidebarMenuCollapsible icon={<Falcon icon="cog"/>} label={t({ comment: 'Sidebar menu - Settings label', message: 'Settings', context: 'sidebar' })} activeChild={activeChild} collapsibleKey="settings" open={collapsibleStates.settings} onToggle={toggleCollapsible}>
      <CollapsibleItemLink to="/users-teams" label={t({ comment: 'Sidebar menu - Users & teams label', message: 'Users & teams', context: 'sidebar' })} matchPath={['/users-teams']}/>
      {userRole.can('manage:settings') && (<CollapsibleItemLink to="/account" label={t({ comment: 'Sidebar menu - Account label', message: 'Account', context: 'sidebar' })} matchPath={['/account']}/>)}
      <CollapsibleItemLink to="/integrations" label={t({ comment: 'Sidebar menu - Integrations', message: 'Integrations', context: 'sidebar' })} matchPath={['/integrations']}/>
      {isWorkflowsAvailable && (<CollapsibleItemLink to="/rules" label={t({
                comment: 'Sidebar menu - Workflows',
                message: 'Approval & signatory rules',
                context: 'sidebar',
            })} matchPath={['/rules']}/>)}
    </SidebarMenuCollapsible>);
}
